import supabase from '../../supabase/supabase';

/**
 * HOUSEHOLD API
 */

export const getMyHouseholds = async (userId) => {
  const { data, error } = await supabase
    .from('members_20240320')
    .select(`
      role,
      household:households_20240320 (
        id,
        name
      )
    `)
    .eq('user_id', userId);

  if (error) throw error;
  
  // Filter out any null households (safety check)
  return data
    .filter(m => m.household)
    .map(m => ({
      id: m.household.id,
      name: m.household.name,
      role: m.role
    }));
};

export const renameHousehold = async (householdId, name) => {
  const { error } = await supabase
    .from('households_20240320')
    .update({ name })
    .eq('id', householdId);
  if (error) throw error;
};